import React from "react";
import "../css/footer.css";

const Footer = (props) => {
  return (
    <div className="footer">
      <p></p>
    </div>
  );
};

export default Footer;
